// const server = "http://localhost";
// const port = 9122;
// const domain = "localhost";
const serverImg = 'https://fercoven.nbg1.your-objectstorage.com/public'
const server = 'https://api.fercoven.com'
const port = 443
const domain = 'fercoven.com'
export { serverImg, server, port, domain }
